import { render, staticRenderFns } from "./CollectionsList.vue?vue&type=template&id=158e46d9&"
import script from "./CollectionsList.vue?vue&type=script&lang=js&"
export * from "./CollectionsList.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports